import { toValue, type MaybeRef } from '@vueuse/core';
import { useStickyAtbSlideoutContextEnabled } from './context-providers/useStickyAtbSlideoutContextEnabled';
import useIsolatedStickyAtbStateStore from '../stores/useIsolatedStickyAtbStateStore';
import { usePageData } from '~/composables/usePageData';

export function useStickifiedContextData() {
  const { traits, productType, productId } = usePageData();
  const { pageLevelFeatureFlags: { isStickyAtbEnabled = false } = {} } = productType?.[productId] ?? {};
  const stickyAtbStore = useIsolatedStickyAtbStateStore();
  const isAppContextStickyEnabled = (() => {
    if (!isStickyAtbEnabled) return false;
    return useStickyAtbSlideoutContextEnabled().isStickyAtbSlideoutContextEnabled;
  })();

  const getStickifiedContext = <T = unknown>(stickifiedValue: MaybeRef<T>, defaultValue: MaybeRef<T>) =>
    toValue(isAppContextStickyEnabled ? stickifiedValue : defaultValue);

  const getStickifiedContextName = <T = string | number>(defaultValue: MaybeRef<T>, ignoreContextCheck: boolean = false): string | T => {
    const unrefValue = toValue(defaultValue);
    return ignoreContextCheck || isAppContextStickyEnabled ? stickyAtbStore.getStickyAtbUUIDSuffix(unrefValue) : unrefValue;
  };

  const getPageDataTraits = () => getStickifiedContext(stickyAtbStore.pageDataStickyAtbTraits, traits);

  return {
    getStickifiedContextName,
    getPageDataTraits,
  };
}
